import { useEffect, useState } from "react";
import "./AppTimeOff.css";
import { CalendarPlus, Captions, UserPlus, FileText, Calendar, Gift, Calculator } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import { AppPTOPolicies } from "./AppPTOPolicies";
import { useDispatch, useSelector } from "react-redux";
import { selectUIStates, selectUser, setUIStates } from "../../../redux/features/appData";
import { apiGetPaidTimeOffPoliciesForWorkspace } from "../../../services/PaidTimeOffPolicyService";
import { PaidTimeOffPolicy } from "winslow-core";
import { AppPTORequests } from "./AppPTORequests";
import { AppPTOSchedule } from "./AppPTOSchedule";
import { AppCompanyHolidays } from "./AppCompanyHolidays";
import { AppPTOAccrualCalculator } from "./AppPTOAccrualCalculator";
import { use } from "marked";
import { ActionLink } from "../../../ds2/components/ActionLink";
import { Action } from "@radix-ui/themes/dist/cjs/components/alert-dialog";
import { Button } from "../../../ds2/components";

export const POLICY_EDITOR_TABS = {
    REQUESTS: "time-off-requests",
    POLICIES: "time-off-policies",
    SCHEDULE: "time-off-schedule",
    HOLIDAYS: "time-off-holidays",
    ACCRUAL: "time-off-accrual"
}

type AppTimeOffProps = {
    
}

export const AppTimeOff = ({} : AppTimeOffProps) => {

    const storeUser = useSelector(selectUser)
    const uiStates = useSelector(selectUIStates);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const params = useParams();
    
    const [tab, setTab] = useState<string>(POLICY_EDITOR_TABS.REQUESTS);

    const [showAddingHoliday, setShowAddingHoliday] = useState<boolean>(false);
    const [showAddingPolicy, setShowAddingPolicy] = useState<boolean>(false);

    const [ptoPolicies, setPtoPolicies] = useState<PaidTimeOffPolicy[] | undefined>(undefined);

    useEffect(() => {
        dispatch(setUIStates({...uiStates, hrisLocation: "Time Off"}));
    }, []);

    useEffect(() => {
        if (!storeUser?.currentWorkspaceId) {
            return;

        }   
        // Fetch PTO policies from the server
        (async () => {
            const ptoPolicies = await apiGetPaidTimeOffPoliciesForWorkspace(storeUser.currentWorkspaceId || "");

            if (ptoPolicies) {
                setPtoPolicies(ptoPolicies);
            }

        })();
    }, []);

    useEffect(() => {
        if (params.tab) {
            setTab(params.tab as string);
        }
    }, [params.tab]);

    return (
        <div className="app-time-off">
            <div className="app-time-off-tabs">
                <div 
                    className={tab === POLICY_EDITOR_TABS.REQUESTS ? 
                        "app-time-off-tab-selected" : "app-time-off-tab"
                    }
                    onClick={() => setTab(POLICY_EDITOR_TABS.REQUESTS)}
                >
                    <FileText size={16} />
                    <span>Requests</span>
                </div>
                <div 
                    className={tab === POLICY_EDITOR_TABS.POLICIES ? 
                        "app-time-off-tab-selected" : "app-time-off-tab"
                    }
                    onClick={() => setTab(POLICY_EDITOR_TABS.POLICIES)}
                >
                    <Captions size={16} />
                    <span>Policies</span>
                </div>
                <div 
                    className={tab === POLICY_EDITOR_TABS.SCHEDULE ? 
                        "app-time-off-tab-selected" : "app-time-off-tab"
                    }
                    onClick={() => setTab(POLICY_EDITOR_TABS.SCHEDULE)}
                >
                    <Calendar size={16} />
                    <span>Schedule</span>
                </div>
                <div 
                    className={tab === POLICY_EDITOR_TABS.HOLIDAYS ? 
                        "app-time-off-tab-selected" : "app-time-off-tab"
                    }
                    onClick={() => setTab(POLICY_EDITOR_TABS.HOLIDAYS)}
                >
                    <Gift size={16} />
                    <span>Holidays</span>
                </div>
                <div 
                    className={tab === POLICY_EDITOR_TABS.ACCRUAL ? 
                        "app-time-off-tab-selected" : "app-time-off-tab"
                    }
                    onClick={() => setTab(POLICY_EDITOR_TABS.ACCRUAL)}
                >
                    <Calculator size={16} />
                    <span>Accrual Calculator</span>
                </div>

                <div className="app-time-off-tab-actions">
                    {tab === POLICY_EDITOR_TABS.POLICIES && !showAddingPolicy &&
                        <ActionLink
                            label="Add Policy"
                            leftIcon={<UserPlus size={16}/>}
                            onClick={() => {
                                setShowAddingPolicy(true);
                                // navigate("/app/time-off/policy-editor/new");
                            }}
                        />
                            
                    }
                    {tab === POLICY_EDITOR_TABS.POLICIES && showAddingPolicy &&
                        <ActionLink
                        label="View Policies"
                        leftIcon={<UserPlus size={16}/>}
                        onClick={() => {
                            setShowAddingPolicy(false);
                            // navigate("/app/time-off/policy-editor/new");
                        }}
                    />
                    }
                    {tab === POLICY_EDITOR_TABS.REQUESTS &&
                        <ActionLink
                            label="Request Time Off"
                            leftIcon={<Captions size={16}/>}
                            onClick={() => {
                                navigate("/app/employee/time-off/request");
                            }}
                        />
                    }
                    {tab === POLICY_EDITOR_TABS.HOLIDAYS && !showAddingHoliday &&
                         <ActionLink
                            label="Add Holiday"
                            leftIcon={<Captions size={16}/>}
                            onClick={() => {
                                setShowAddingHoliday(true);
                                // navigate("/app/employee/time-off/request");
                         }}
                     />
                    }
                    {tab === POLICY_EDITOR_TABS.HOLIDAYS && showAddingHoliday &&
                        <ActionLink
                            label="View Holidays"
                            leftIcon={<CalendarPlus size={16}/>}
                            onClick={() => {
                                setShowAddingHoliday(false);
                                // navigate("/app/time-off/holidays/new");
                            }}
                        />
                        // <div
                        //     className="app-time-off-tab-action"
                        //     onClick={() => {
                        //         navigate("/app/time-off/holidays/new");
                        //     }}
                        // >
                        //     <CalendarPlus size={16}/> Add a New Holiday
                        // </div>
                    }
                    
                </div>
                
            </div>

            {POLICY_EDITOR_TABS.REQUESTS === tab &&
                <AppPTORequests />
            }
            {POLICY_EDITOR_TABS.POLICIES === tab &&
                <AppPTOPolicies 
                    ptoPolicies={ptoPolicies}
                    showAddingPolicy={showAddingPolicy}
                    onCancel={()=>{setShowAddingPolicy(false)}}
                />
            }
            {POLICY_EDITOR_TABS.SCHEDULE === tab &&
                <AppPTOSchedule />
            }
            {POLICY_EDITOR_TABS.HOLIDAYS === tab &&
                <AppCompanyHolidays
                    showAddingHoliday={showAddingHoliday}
                    onCancel={()=>{setShowAddingHoliday(false)}}
                />
            }
            {POLICY_EDITOR_TABS.ACCRUAL === tab &&
                <AppPTOAccrualCalculator />
            }
        </div>
    );
}